import get from 'lodash/get';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  contentClick,
  loadMoreInteraction,
  sectionNameDataLayer,
} from '../../../../../helpers/datalayer-utils';
import { ArrowRightIcon, ChevronRightIcon, TextBoxIcon } from '../../../../atoms/material-icons';
import EmptyState from '../empty-state';
import ResearchReportCard from '../research-report-card';
import './research-reports.m.css';
const ResearchReports = ({ widget = false }) => {
  const widgetParam = widget ? '?view=apps' : '';
  const [researchReports, setResearchReports] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const [isDarkMode, setIsDarkMode] = useState(false);
  const NDTV_SEARCH_API_CONFIG = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'aiSummary'], {}),
  );

  const getReports = async () => {
    const queryParams = new URLSearchParams(window.location?.search);
    let utmCampaign = queryParams?.get('utm_campaign');
    if (!utmCampaign) {
      const response = await fetch(`${NDTV_SEARCH_API_CONFIG?.url}${NDTV_SEARCH_API_CONFIG?.client_key}${NDTV_SEARCH_API_CONFIG?.story_params}&pagesize=10&${NDTV_SEARCH_API_CONFIG?.research_param}`);
      const data = await response.json();
      setResearchReports(data?.results || []);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    getReports();
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(mediaQuery.matches);

    const handleChange = (e) => setIsDarkMode(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="research-container">
      <div styleName="header-title-container">
        <TextBoxIcon size={'26px'} color={'#d01e51'} />
        <a
          href={`/research-reports${widgetParam}`}
          onClick={() => sectionNameDataLayer('Research Reports', userData, pageType)}
        >
          <h4 styleName="list-header-title">
            Research Reports
            <ChevronRightIcon
              size={'30px'}
              color={isDarkMode && widget ? '#FFFFFF' : '#2b2b2b'}
              styleName="header-tab-icon"
            />
          </h4>
        </a>
      </div>
      {researchReports && researchReports?.length > 0 ? (
        <>
          <div styleName="research-content">
            <div styleName="headline-container">
              {researchReports.slice(0, 6).map((report, index) => (
                <ResearchReportCard
                  key={index}
                  report={report}
                  onClickDl={() => contentClick(userData, report, pageType)}
                />
              ))}
            </div>
          </div>
          <div
            styleName="mob-button-container"
            onClick={() =>
              loadMoreInteraction('Show All Reports', userData, pageType, 'Research Reports')
            }
          >
            <a
              styleName="detailed-report-btn"
              href={`/research-reports${widgetParam}`}
              target="_blank"
              rel="noreferrer"
            >
              Show All Reports
              <ArrowRightIcon
                styleName="tab-icon"
                color={isDarkMode && widget ? '#FFFFFF' : '#2b2b2b'}
              />
            </a>
          </div>
        </>
      ) : (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState />
          </div>
        </div>
      )}
    </div>
  );
};

export default ResearchReports;
